export class BossSetup {
  private constructor() {}

  static maxBossCampPopulation = 10;

  static bossGroupSize = 20;
}
